import { Icon } from '@chakra-ui/react';
import { X } from '@kula-ai/icons-core';

export const FilterClose = ({ onClose = () => {}, color = 'primary-600' }) => {
  return (
    <Icon
      as={X}
      color={color}
      w="10px"
      h="10px"
      cursor="pointer"
      onClick={(e) => {
        // Prevent the parent event from bubbling.
        if (e && e.stopPropagation) e.stopPropagation();
        onClose();
      }}
    />
  );
};
